import script from "./ElementPickerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ElementPickerModal.vue?vue&type=script&setup=true&lang=js"

import "./ElementPickerModal.vue?vue&type=style&index=0&id=a6215360&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6215360"]])

export default __exports__